import React, {useEffect} from "react";
import './AnalizaMain.css'
import MathJax from 'react-mathjax-preview';
import TeX from '@matejmazur/react-katex';
import {useHistory} from "react-router-dom";
import * as BiIcons from "react-icons/bi";

export default function Logika(){

    useEffect(()=>{
        document.title="Podstawy logiki";
    },[])

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza/pojecia-wstepne');
    }

    return(
      <div className='conceptsContainer'>
          <div className='comeBackDiv' onClick={comeBackFunc}>
              <BiIcons.BiArrowBack/>
              <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
          </div>

          <h2>Wyrażenia logiczne:</h2>
          <p className='oneLine centerVertical'><MathJax math={'`&#8764;p`'}/>, oznacza: nieprawda, że &nbsp;<TeX math={'p'}/></p>
          <p className='oneLine centerVertical'><MathJax math={'`p &#8744; q`'}/>, oznacza: &nbsp;<TeX math={'p'}/> &nbsp;lub
              &nbsp;<TeX math={'q'}/></p>
          <p className='oneLine centerVertical'><MathJax math={'`p &#8743; q`'}/>, oznacza: &nbsp;<TeX math={'p'}/> &nbsp;i
              &nbsp;<TeX math={'q'}/></p>
          <p className='oneLine centerVertical'><MathJax math={'`p &#8658; q`'}/>, oznacza: jeśli &nbsp;<TeX math={'p'}/> &nbsp;
              to &nbsp;<TeX math={'q'}/> &nbsp; lub z &nbsp;<TeX math={'p'}/> &nbsp; wynika &nbsp;<TeX math={'q'}/> &nbsp;</p>
          <p className='oneLine centerVertical'>Jeżeli &nbsp;<MathJax math={'`p&#8658;q`'}/> &nbsp;oraz&nbsp;
              <MathJax math={'`q&#8658;p`'}/> &nbsp;to możemy zastosować zapis:</p>
          <p className='oneLine centerVertical'><MathJax math={'`p &#8660; q`'}/>&nbsp;lub&nbsp;<MathJax math={'`p &#8801; q`'}/></p>
      </div>
    );
}